import React from 'react';
import Button from '@fec/frontend/elements/buttons/button/button';
import classNames from 'classnames';

import './swipeable.scss';

export const Swipeable = ({
  translations,
  children,
  visuallyHidden = false,
}) => {
  return (
    <>
      <ul
        className={classNames(
          'collection-ng__teaser-list js-teaser-ng-list js-collection-ng-swipeable-container',
          {
            'h-element--hide': visuallyHidden,
          },
        )}
        data-flying-focus-info="ignore-scrollable-container"
        data-event-name={translations.playSubtitle}
        data-event-source="collection-swipeable">
        {children}
      </ul>

      <div
        className="collection-ng__swipeable-controls js-collection-ng-swipeable-controls h-element--hide"
        aria-hidden>
        <Button
          tag="span"
          styleModifier="button--icon-only collection-ng__swipeable-button collection-ng__swipeable-button--prev js-swipeable-control-left"
          svgIcon="svg-icon--arrow-left"
          screenReaderText={translations.scrollLeft}
        />

        <Button
          tag="span"
          styleModifier="button--icon-only collection-ng__swipeable-button collection-ng__swipeable-button--next js-swipeable-control-right"
          svgIcon="svg-icon--arrow-right"
          screenReaderText={translations.scrollRight}
        />
      </div>
    </>
  );
};

export default Swipeable;
